export default function () {
    return (
        <>
            <b>PRIVACY POLICY</b>
            <p/>

            <b>Information We Collect</b>
            <p>
                We limit personal information collection to what is required to provide and secure our services. When you register for or access our application, we collect the following personal information:
            </p>
            <p>
                <b>Information We Collect Directly From You</b>: Contact details including name, email address, address, and company affiliation.
            </p>
            <p>
                <b>Information We Collect About Your Usage</b>: We may also automatically collect certain information about your interaction with the Services (“Usage Data”). To do this, we may use cookies and similar technologies. Usage may include information about how you access and use our site and your account, including device information, browser information, information about your network connection, your IP address, and other information regarding your interaction with the Services.
            </p>
            <p>
                <b>Information we obtain from Third Parties</b>: We may obtain information about you from third parties, including from vendors and service providers who may collect information on our behalf.
            </p>

            <b>How We Use Your Information</b>
            <p>
                We use the collected information solely for legitimate operational and service purposes:
            </p>
            <ul>
                <li>To create, authenticate, and maintain your user account.</li>
                <li>To provide you with and maintain our core features and services</li>
                <li>To enable you to customize or personalize your experience of our services</li>
                <li>To communicate essential product updates, maintenance alerts, and administrative notices.</li>
                <li>To respond to support requests or inquiries you initiate.</li>
                <li>To protect against unauthorized account access, fraud, or misuse of our services.</li>
            </ul>

            <b>Data Sharing and Third-Party Service Providers</b>
            <p>
                We do not share your personal information with third parties except in the following limited circumstances:
            </p>
            <ul>
                <li>
                    <b>Essential Service Providers:</b> We may process your data through trusted third-party infrastructure providers necessary to run our software (such as secure cloud hosting, database management, or transactional email services). These providers are strictly bound by contractual obligations to keep your information confidential and secure.
                </li>
                <li>
                    <b>Legal Compliance:</b> We may disclose your information if required to do so by applicable law, regulation, or a valid legal request (such as a subpoena or court order).
                </li>
            </ul>

            <b>Data Security and Retention</b>
            <ul>
                <li>
                    <b>Security:</b> We employ industry-standard administrative, technical, and physical security measures designed to safeguard your name and email address against loss, theft, and unauthorized access.
                </li>
                <li>
                    <b>Retention:</b> We retain your account information for as long as your account remains active or as needed to fulfill our legal obligations and resolve disputes.
                </li>
            </ul>

            <b>Your Privacy Rights and Data Control</b>
            <p>
                Depending on your geographic location (e.g., California, European Union/UK, or applicable U.S. state privacy laws), you have specific rights regarding your personal information:
            </p>
            <ul>
                <li>
                    <b>Access &amp; Portability:</b> You may request details on the personal data we hold about you.
                </li>
                <li>
                    <b>Correction:</b> You may update or correct your name and contact information details at any time through your account settings or by contacting support.
                </li>
                <li>
                    <b>Deletion:</b> You may request the permanent deletion of your account and associated personal data at any time.
                </li>
            </ul>
            <p>
                To exercise any of these rights, please contact us at <a href="mailto:support@rasreview.com" style={{textDecoration: 'none'}}>support@rasreview.com</a>.
            </p>

            <b>Updates to This Policy</b>
            <p>
                At our discretion, we may change our Privacy Policy to reflect updates to our business processes, current acceptable practices, or legislative or regulatory changes. If we decide to change this Privacy Policy, we will post the changes here at the same link by which you are accessing this Privacy Policy with an updated Effective Date.
            </p>

            <b>Contact Us</b>
            <p>
                If you have questions, concerns, or requests regarding this Privacy Policy or our data handling practices, please reach out to: <a href="mailto:support@rasreview.com" style={{textDecoration: 'none'}}>support@rasreview.com</a>.
            </p>
        </>
    )
}
